<template>
    <div class="automation-trigger-settings">
        <p>{{ t('automations-form-triggers_config-periodic-description') }}</p>
        <div class="field">
            <label :class="{ label: true }">
                <input
                    type="radio"
                    value="monthly"
                    v-model="type"
                    @change="day = []"
                />
                {{ t('automations-form-triggers_config-periodic-send_monthly') }}
            </label>
            <div v-if="type === 'monthly'">
                <div class="days-list monthly">
                    <label v-for="dayNumber in monthDays" :key="dayNumber">
                        <input
                            type="checkbox"
                            :value="dayNumber + 1"
                            v-model="day"
                        />
                        <!-- i18n-validator-ignore-next-line: raw number -->
                        {{ dayNumber + 1 }}
                    </label>
                </div>
                {{ t('automations-form-triggers_config-periodic-at_label') }}
                <datetime-with-clear
                    type="time"
                    :zone="placeTimezone"
                    :value-zone="placeTimezone"
                    v-model="time"
                    style="width: 100px; display: inline-block"
                ></datetime-with-clear>
            </div>
            <label :class="{ label: true }">
                <input
                    type="radio"
                    value="weekly"
                    v-model="type"
                    @change="day = []"
                />
                {{ t('automations-form-triggers_config-periodic-send_weekly') }}
            </label>
            <div v-if="type === 'weekly'">
                <div class="days-list">
                    <label>
                        <input type="checkbox" :value="1" v-model="day" /> {{ t('automations-form-triggers_config-periodic-week_days-mon') }}
                    </label>
                    <label>
                        <input type="checkbox" :value="2" v-model="day" /> {{ t('automations-form-triggers_config-periodic-week_days-tue') }}
                    </label>
                    <label>
                        <input type="checkbox" :value="3" v-model="day" /> {{ t('automations-form-triggers_config-periodic-week_days-wed') }}
                    </label>
                    <label>
                        <input type="checkbox" :value="4" v-model="day" /> {{ t('automations-form-triggers_config-periodic-week_days-thu') }}
                    </label>
                    <label>
                        <input type="checkbox" :value="5" v-model="day" /> {{ t('automations-form-triggers_config-periodic-week_days-fri') }}
                    </label>
                    <label>
                        <input type="checkbox" :value="6" v-model="day" /> {{ t('automations-form-triggers_config-periodic-week_days-sat') }}
                    </label>
                    <label>
                        <input type="checkbox" :value="7" v-model="day" /> {{ t('automations-form-triggers_config-periodic-week_days-sun') }}
                    </label>
                </div>
                {{ t('automations-form-triggers_config-periodic-at_label') }}
                <datetime-with-clear
                    type="time"
                    :zone="placeTimezone"
                    :value-zone="placeTimezone"
                    v-model="time"
                    style="width: 100px; display: inline-block"
                ></datetime-with-clear>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.days-list {
    display: grid;
    margin: 20px 0;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
}
</style>
<script>
import DatetimeWithClear from "../../../components/datetime-with-clear/datetime-with-clear.vue";

export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    components: {
        "datetime-with-clear": DatetimeWithClear,
    },
    data: function () {
        let type =
            this.value.length > 0 && this.value[0].type
                ? this.value[0].type
                : null;
        let day =
            this.value.length > 0 && this.value[0].day ? this.value[0].day : [];
        if (!Array.isArray(day)) {
            day = [day];
        }
        let time =
            this.value.length > 0 && this.value[0].time
                ? this.value[0].time
                : null;
        return {
            type,
            day,
            time,
            initialized: false,
        };
    },
    computed: {
        monthDays() {
            return [...Array(31).keys()];
        },
        placeTimezone() {
            return (
                (this.$store.state.place && this.$store.state.place.timezone) ||
                "America/Sao_Paulo"
            );
        },
    },
    mounted() {
        window.setTimeout(() => {
            this.changed();
        }, 100);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        isValid() {
            if (!["weekly", "monthly"].includes(this.type)) {
                return false;
            }

            if (!this.time || typeof this.time !== "string" || this.time.trim() === "") {
                return false;
            }

            if (this.type === "weekly") {
                return this.day.every((d) => d >= 1 && d <= 7);
            } else {
                return this.day.every((d) => d >= 1 && d <= 31);
            }
        },
        changed: function () {
            this.$emit("input", [
                {
                    day: this.day,
                    type: this.type,
                    time: this.time,
                },
            ]);
        },
    },
    watch: {
        day() {
            this.changed();
        },
        type() {
            this.changed();
        },
        time() {
            this.changed();
        },
        value() {
            let type = this.value[0].type;
            if (type !== this.type) {
                this.type = type;
            }
            let day = this.value[0].day;
            if (day && !Array.isArray(day)) {
                day = [day];
            }
            if (day !== this.day) {
                this.day = day;
            }

            let time = this.value[0].time;
            if (time !== this.time) {
                this.time = time;
            }
        },
    },
};
</script>
